import { atom, useAtom, useAtomValue } from "jotai";
import type { HowManyToList } from "./constants";

export const howManyToListAtom = atom<HowManyToList>();

export const useHowManyToListState = () => useAtom(howManyToListAtom);
export const useHowManyToListValue = () => useAtomValue(howManyToListAtom);
